import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatBytes(bytes: number, locale = navigator.language) {
  // Handle zero or very small values
  if (bytes === 0) {
    return new Intl.NumberFormat(locale, {
      style: 'unit',
      unit: 'byte',
      unitDisplay: 'short',
    }).format(0)
  }

  const units = [
    'byte',
    'kilobyte',
    'megabyte',
    'gigabyte',
    'terabyte',
    'petabyte',
  ]
  // Use 1024 for binary-based (IEC) conversion
  const i = Math.floor(Math.log(bytes) / Math.log(1024))
  const value = bytes / Math.pow(1024, i)
  const unit = units[i]

  if (!unit) {
    return bytes.toLocaleString(locale)
  }

  return new Intl.NumberFormat(locale, {
    style: 'unit',
    unit: unit,
    unitDisplay: 'short',
    maximumFractionDigits: 1,
  }).format(value)
}

export function downloadMarkdownFile(opts: { filename: string; text: string }) {
  const { text, filename } = opts
  const blob = new Blob([text], { type: 'text/markdown' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `${filename.length > 0 ? filename : 'new-tailored-resume'}.md`
  a.click()
  URL.revokeObjectURL(url)
}
